<style lang="scss" src='./KnowledgeBase.scss' scoped></style>
<template src="./KnowledgeBase.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';
  import { 
    addKnowledgeCategory, 
    updateKnowledgeCategory, 
    deleteKnowledgeCategory,
    updateKnowledgeFile,
    deleteKnowledgeFile,
  } from '@/api/index';
  
  export default {
    name: 'KnowledgeBase',
    components: {
    },
    
    data() {
      return {
        category: {},
        selectedCategory: {},
        file: {},
        selectedFile: {},
        file2Upload: {},
        editingCategory: false,
        editingFile: false
      };
    },

    computed: {

      makeRows(){
        let row = [];
        let i,l, chunkSize = 2; 

        for (i = 0, l = this.categories.length; i < l; i += chunkSize) {
          row.push(this.categories.slice(i, i + chunkSize));
        }

        return row;
      },

      ...mapState('KnowledgeBase', {
        categories: (state) => state.categories,
        loading: (state) => state.loading,
        userCanUpdate: (state) => state.userCanUpdate,
      }),
    },

    methods: {

      async saveCategory(){
        if(this.category && this.category.name){
          this.setLoading({addingCategory: true});
          
          if(this.editingCategory){
            await this.updateCategory(this.category);
          }else{
            await this.addNewCategory(this.category);
          }

          this.$bvModal.hide('md-add-category');
          this.category = {};
        }
      },

      async addNewCategory(category) {

        await addKnowledgeCategory(category).then( async (category) => {
          this.addCategory(category);
        }).finally(() => {
          this.setLoading({addingCategory: false});
        });

      },

      editCategory(index1, index2) {
        this.selectedCategory = this.makeRows[index1][index2];
        let category = {...this.selectedCategory};
        this.category = category;
        this.editingCategory = true;

        this.$bvModal.show('md-add-category');
      },

      async updateCategory(category){
        
        await updateKnowledgeCategory({ name: category.name }, this.selectedCategory.knowledge_category_id).then( async (category) => {
          this.selectedCategory.name = category.name
        }).finally(() => {
          this.setLoading({addingCategory: false});
          this.editingCategory = false;
          this.category = {};
        });

      },

      deleteCategory(index1, index2) {
        this.category = this.makeRows[index1][index2];
        const index = (2 * index1)  + index2;
        
        this.G_Alert_v2({ style: this.consts.Style.DANGER, 
                            message: this.$t('knowledgeBase.delCategoryConfirm'),
                            fnOk: () => {
                              deleteKnowledgeCategory(this.category.knowledge_category_id)
                              .then(() => {
                                this.removeCategory(index);
                                this.category = {};
                              });
                            }
                          });
      },

      showAddFileModal(index1, index2) {
        this.category = this.makeRows[index1][index2];
        
        this.$bvModal.show('md-add-file');
      },

      onNewFileSelected(event) {
        this.G_createUrlFromFile(event, (mFile)=> {
          this.file2Upload = mFile;
        });
      },

      async saveFile(){
        if(this.file && this.file.name){
          this.setLoading({addingFile: true});
          
          if(this.editingFile){
            await this.updateFile(this.file);
          }else{
            await this.addNewFile(this.file);
          }

          this.$bvModal.hide('md-add-file');
          this.file = {};
        }
      },

      async addNewFile(file) {
        
        if (this.file2Upload && this.file2Upload.file) {
          await this.uploadKnowledgeFile({knowledge_category_id: this.category.knowledge_category_id, file2Upload: this.file2Upload, name: this.file.name}).then( async (knwoledge_file) => {
            if(knwoledge_file && knwoledge_file.data && knwoledge_file.data.data && knwoledge_file.data.data.knowledge_file_id){
              this.category.files = [...this.category.files, knwoledge_file.data.data];
            }

          }).finally(() => {
            this.setLoading({addingFile: false});
            this.category = {};
          });
        }else{
          this.setLoading({addingFile: false});
          this.category = {};
        }
      },

      editFile(index1, index2, index3) {
        this.selectedCategory = this.makeRows[index1][index2];
        this.selectedFile = this.selectedCategory.files[index3];
        let file = {...this.selectedFile}
        this.file = file;
        this.editingFile = true;

        this.$bvModal.show('md-add-file');
      },

      async updateFile(file){
        
        await updateKnowledgeFile({ name: file.name }, this.selectedFile.knowledge_file_id).then( async (file) => {
          this.selectedFile.name = file.name
        }).finally(() => {
          this.setLoading({addingFile: false});
          this.editingFile = false;
          this.file = {};
        });

      },

      deleteFile(index1, index2, index3) {
        this.category = this.makeRows[index1][index2];
        this.file = this.category.files[index3];
        const index = (2 * index1)  + index2;
        const indexFile = index3;

        this.G_Alert_v2({ style: this.consts.Style.DANGER, 
                            message: this.$t('knowledgeBase.delFileConfirm'),
                            fnOk: () => {
                              deleteKnowledgeFile(this.file.knowledge_file_id)
                              .then(() => {
                                this.removeFile([index, indexFile]);
                                this.category = {};
                                this.file = {};
                              });
                            }
                          });
      },

      closeModal() {
        this.editingCategory = false;
        this.editingFile = false;
        this.category = {};
        this.file = {};
        this.setLoading({addingCategory: false, addingFile: false});
        this.file2Upload = {};
      },

      loadData() {
        this.loadCategories();
      },

      ...mapActions('KnowledgeBase', ['loadCategories','setUserCanUpdate', 'uploadKnowledgeFile']),
      
      ...mapMutations('KnowledgeBase', ['setLoading', 'addCategory', 'removeCategory', 'removeFile']),
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Knowledge Base");
        this.$analytics.logEvent("web_knowledge_base");
      }

      if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
        this.setUserCanUpdate(true);
      }
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
